import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import TextField from '@mui/material/TextField'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { classnames } from '../../../../helpers'
import { useStates } from '../../../../StateProvider'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from './autocomplete'
import './autocomplete/auto_complete.css'

const FromSearchBar = (props) => {
  const [inputValue, setInputValue] = useState(
    localStorage.removeItem('fromSearchAddress') || ''
  )
  const [address, setAddress] = useState(
    localStorage.removeItem('fromSearchAddress') || ''
  )
  const [errorMessage, setErrorMessage] = useState('')
  const [latitude, setLatitude] = useState(null)
  const [longitude, setLongitude] = useState(null)
  const [addressComponent, setAddressComponent] = useState(null)

  const handleChange = (newAddress) => {
    setInputValue(newAddress)
    setAddress(newAddress) // Update the address state with the new input value
    setLatitude(null)
    setLongitude(null)
    setAddressComponent(null)
    setErrorMessage('')
  }

  const { searchFor } = useStates()

  const handleSelect = (selected) => {
    console.log('testLogging:', process.env.REACT_APP_GOOGLE_APIS_KEY)
    localStorage.removeItem('fromSearchAddress', selected)
    setAddress(selected)
    geocodeByAddress(selected)
      .then((res) => {
        res[0].address_components &&
          setAddressComponent(res[0].address_components)
        return getLatLng(res[0])
      })
      .then(async ({ lat, lng }) => {
        setLatitude(lat)
        setLongitude(lng)

        // console.log('Latitude:', lat, 'Longitude:', lng)
        // console.log('REACT_APP_GOOGLE_APIS_KEY:', process.env.REACT_APP_GOOGLE_APIS_KEY)

        // Call Google Time Zone API
        const timestamp = Math.floor(Date.now() / 1000) // Current timestamp in seconds
        const timeZoneAPI = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.REACT_APP_GOOGLE_APIS_KEY}`

        try {
          const response = await fetch(timeZoneAPI)
          const data = await response.json()

          // console.log('UTC OffsetTest from:', data)
          if (data.status === 'OK') {
            const localTimeZone = dayjs.tz.guess()
            const formattedLocalTime = dayjs().tz(localTimeZone)
            const formattedLocalTimeWithOffset = formattedLocalTime.add(10, 'minutes')
            props.setDepartTime(formattedLocalTimeWithOffset)
            props.setFromTimeZone(data?.timeZoneId)
          } else {
            console.error('Time Zone API Error:', data.status)
          }
        } catch (error) {
          console.error('Error fetching time zone:', error)
        }
      })
      .catch((error) => {
        console.error('error', error)
      })
  }

  useEffect(() => {
    if (inputValue === '') {
      localStorage.removeItem('fromSearchAddress', '')
    }
  }, [inputValue])

  const handleError = (status, clearSuggestions) => {
    let errorMessage = status
    if (status === 'ZERO_RESULTS') {
      errorMessage = 'This address is not found, try to search USA locations'
    }
    setErrorMessage(errorMessage)
    clearSuggestions()
  }

  React.useEffect(() => {
    props.setLat(latitude)
    props.setLong(longitude)
    if (props?.setAddress) {
      props?.setAddress(addressComponent)
    }
  }, [latitude, longitude, addressComponent, props])

  useEffect(() => {
    geocodeByAddress(address)
      .then((res) => {
        res[0].address_components &&
          setAddressComponent(res[0].address_components)
        return getLatLng(res[0])
      })
      .then(({ lat, lng }) => {
        setLatitude(lat)
        setLongitude(lng)
      })
      .catch((error) => {
        console.error('error', error)
      })
  }, [address])

  return (
    <div>
      <PlacesAutocomplete
        onChange={handleChange}
        value={address} // Use address state as the value for PlacesAutocomplete
        onSelect={handleSelect}
        onError={handleError}
        shouldFetchSuggestions={address?.length > 2}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps }) => {
          return (
            <div className="Demo__search-bar-container">
              <div className="Demo__search-input-container">
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value)
                    setAddress(e.target.value)
                  }}
                  {...getInputProps({
                    placeholder: 'Search Places...',
                    className: 'Demo__search-input'
                  })}
                  fullWidth
                  sx={{
                    width:
                      searchFor === 'setPosition' ? '370px !important' : '100%',
                    paddingLeft: '0px !important',
                    margin: '0 auto',
                    '& .MuiInputLabel-root': {
                      marginLeft: '-15px',
                      color: '#a3a3a3b3',
                      fontFamily: '"Poppins", sans-serif',
                      borderWidth: '0.3px'
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      marginLeft: '-15px',
                      color: '#a3a3a3b3',
                      fontFamily: '"Poppins", sans-serif'
                    },
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Poppins", sans-serif',
                      '& fieldset': {
                        borderColor: '#a3a3a3b3' // Default border color
                      },
                      '&:hover fieldset': {
                        borderColor: '#a3a3a3b3', // Border color on hover
                        borderWidth: '0.3px'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#a3a3a3b3', // Border color on focus
                        borderWidth: '0.3px'
                        // boxShadow: '1px 1px 7px 0px #00000017' // Apply shadow on focus
                      }
                    },
                    '& .MuiInputBase-input::placeholder': {
                      fontFamily: '"Poppins", sans-serif',
                      fontSize: '12px',
                      fontWeight: '400',
                      color: '#858585'
                    }
                  }}
                />
              </div>
              {suggestions.length > 0 && (
                <div className="Demo__autocomplete-container">
                  {suggestions.map((suggestion) => {
                    const className = classnames('Demo__suggestion-item', {
                      'Demo__suggestion-item--active': suggestion.active
                    })
                    return (
                      <div
                        key={suggestion.placeId}
                        {...getSuggestionItemProps(suggestion, { className })}
                        style={{
                          margin: '.4rem 0',
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',
                          fontFamily: "'Poppins', sans-serif !important"
                        }}
                      >
                        <div>
                          <LocationOnOutlinedIcon className="location_icon" />
                        </div>
                        <div>
                          <strong>
                            {suggestion.formattedSuggestion.mainText}
                          </strong>
                          <small className="small_text">
                            {suggestion.formattedSuggestion.secondaryText}
                          </small>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )
        }}
      </PlacesAutocomplete>
      {errorMessage.length > 0 && (
        <div className="Demo__error-message">{errorMessage}</div>
      )}
    </div>
  )
}
export default FromSearchBar
